<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <transition name="modal">
    <div class="modal-mask" v-if="isStitches == 'stitches_yes' && isButtons == 'buttons_no'">
      <fieldset class="form-padding">
        <legend class="field-label">
          {{ $t('Please choose arrangement of top sewings') }}
        </legend>
        <div class="form-group stitches-part-rec">
          <div class="flex gap-4">
            <label class="shape-item flex-1" for="stitches_distribution_simple_split">
              <div class="mb-4">
                <img class="cushion-img" :src="stitchesSimpleSplitRectangleImgPath" />
              </div>
              <div class="inline-flex gap-2">
                <Field
                  name="stitchesDistribution"
                  type="radio"
                  v-model="stitchesDistribution"
                  v-slot="{ field }"
                >
                  <input
                    id="stitches_distribution_simple_split"
                    v-bind="field"
                    required
                    type="radio"
                    class="radio-input"
                    value="stitches_distribution_simple_split"
                    name="stitchesDistribution"
                  />
                </Field>
                <span class="check-text">{{ $t('With equal split') }}</span>
              </div>
            </label>
            <label class="shape-item flex-1" for="stitches_distribution_fixed_distance">
              <div class="mb-4">
                <img class="cushion-img" :src="stitchesFixedDistanceRectangleImgPath" />
              </div>
              <div class="inline-flex gap-2">
                <Field
                  name="stitchesDistribution"
                  type="radio"
                  v-model="stitchesDistribution"
                  v-slot="{ field }"
                >
                  <input
                    id="stitches_distribution_fixed_distance"
                    v-bind="field"
                    required
                    type="radio"
                    class="radio-input"
                    value="stitches_distribution_fixed_distance"
                    name="stitchesDistribution"
                  />
                </Field>
                <span class="check-text">{{ $t('My input for distance to the edge') }}</span>
              </div>
            </label>
          </div>
        </div>
        <div v-if="stitchesDistribution" class="fields-wrapper">
          <div class="row">
            <div class="col flex flex-col gap-4">
              <div>
                <label class="field-label text-lg">
                  <span>{{ $t('Rows of sewings') }}</span>
                </label>

                <Field type="number" v-model="stitchesRows" name="stitchesRows" v-slot="{ field }">
                  <input
                    v-bind="field"
                    name="stitchesRows"
                    class="!field-input appearance-textfield"
                    type="number"
                    inputmode="numeric"
                    :placeholder="$t('Enter the value')"
                    required
                  />
                </Field>
              </div>
              <div>
                <label class="field-label text-lg">
                  <span>{{ $t('Columns of sewings') }}</span>
                </label>

                <Field name="stitchesCols" type="number" v-model="stitchesCols" v-slot="{ field }">
                  <input
                    v-bind="field"
                    class="!field-input appearance-textfield"
                    name="stitchesCols"
                    type="number"
                    inputmode="numeric"
                    :placeholder="$t('Enter the value')"
                    required
                  />
                </Field>
              </div>
              <div  v-if="stitchesDistribution === 'stitches_distribution_fixed_distance'">
                <label
                  class="items-center"

                >
                  <span class="field-label text-lg">{{ $t('Distance to edge') }}</span>
                  <span class="field-condition">{{ $t('Minimum 15 cm') }}</span>
                </label>

                <Field
                  name="stitchesDistanceToEdge"
                  type="number"
                  v-model="stitchesDistanceToEdge"
                  v-slot="{ field }"
                >
                  <input
                    v-bind="field"
                    class="!field-input appearance-textfield"
                    name="stitchesDistanceToEdge"
                    type="number"
                    inputmode="numeric"
                    required
                    :placeholder="$t('Enter the value')"
                  />
                </Field>
              </div>
            </div>
          </div>
        </div>
      </fieldset>
    </div>
  </transition>
</template>

<script setup lang="ts">
import { useStore } from '@/stores/store'
import { storeToRefs } from 'pinia'
import { Field } from 'vee-validate'
import { onMounted, ref } from 'vue'

const store = useStore()
const {
  stitchesDistribution,
  stitchesCols,
  stitchesRows,
  stitchesDistanceToEdge,
  isStitches,
  isButtons,
} = storeToRefs(store)
const stitches_rows_min_value = ref(1)
const stitches_rows_max_value = ref(20)
const stitches_cols_min_value = ref(1)
const stitches_cols_max_value = ref(29)
const stitches_distance_min_value = ref(1)
const stitches_distance_max_value = ref(100)
const default_min = 1
const default_max = 20
const stitchesSimpleSplitRectangleImgPath =
  store.imgPath + '/shapes/stitches-simple-split-rectangle.png'
const stitchesFixedDistanceRectangleImgPath =
  store.imgPath + '/shapes/stitches-fixed-distance-rectangle.png'

onMounted(() => {
  if (import.meta.env.PROD) {
    const stitches_rows_data = document
      ?.querySelector('input[data-sku="stitches_rows"]')
      ?.getAttribute('data-validate')
    stitches_rows_min_value.value = getMinValue(
      stitches_rows_data ? JSON.parse(stitches_rows_data).minvalue : '',
    )
    stitches_rows_max_value.value = getMaxValue(
      stitches_rows_data ? JSON.parse(stitches_rows_data).maxvalue : '',
    )

    const stitches_cols_data = document
      ?.querySelector('input[data-sku="stitches_cols"]')
      ?.getAttribute('data-validate')
    stitches_cols_min_value.value = getMinValue(
      stitches_cols_data ? JSON.parse(stitches_cols_data).minvalue : '',
    )
    stitches_cols_max_value.value = getMaxValue(
      stitches_cols_data ? JSON.parse(stitches_cols_data).maxvalue : '',
    )

    const stitches_distance_data = document
      ?.querySelector('input[data-sku="stitches_edge_distance"]')
      ?.getAttribute('data-validate')
    stitches_distance_min_value.value = getMinValue(
      stitches_distance_data ? JSON.parse(stitches_distance_data).minvalue : '',
    )
    stitches_distance_max_value.value = getMaxValue(
      stitches_distance_data ? JSON.parse(stitches_distance_data).maxvalue : '',
    )
  }
})

function getMinValue(minvalue: string) {
  if (Number.isInteger(parseInt(minvalue))) {
    return Number(minvalue)
  } else {
    return default_min
  }
}
function getMaxValue(maxvalue: string) {
  if (Number.isInteger(parseInt(maxvalue))) {
    return Number(maxvalue)
  } else {
    return default_max
  }
}
</script>

<style scoped></style>
